import { COMPANY_TYPES } from '../../../utils/common'

export const typeComponentCorporate = {
  QUICK_ASSESSMENT: 'quickAssessmentCorporate',
  PROFITABILITY: 'profitability',
  ROA_AND_ROE: 'roaAndRoe',
  ASSET_MANAGEMENT_EFFICIENCY: 'assetManagementEfficiency',
  LIQUIDITY: 'liquidity',
  SOLVENCY: 'solvency',
  COVERAGE: 'coverage',
  EARNING_BREAKDOWN: 'earningBreakdown',
  BALANCE_BREAKDOWN: 'balanceBreakdown',
  CASH_BREAKDOWN: 'cashBreakdown',
}

export const typeComponentBank = {
  QUICK_ASSESSMENT: 'quickAssessmentBank',
  LOAN_BOOK_BREAKDOWN: 'loanBookBreakdown',
  DEPOSIT_AND_CREDIT: 'depositAndCredit',
  AVERAGE_COST: 'averageCost',
  EARNING_QUALITY: 'earningQuality',
  CAPITAL_AND_LEVERAGE: 'capitalAndLeverage',
  LIQUIDITY: 'bankLiquidity',
  FUNDING_STRUCTURE: 'fundingStructure',
  BALANCE_BREAKDOWN: 'bankBalanceBreakdown',
  EARNING_BREAKDOWN: 'bankEarningBreakdown',
  CASH_FLOW: 'cashFlow',
}

export const typeComponentNonBank = {
  QUICK_ASSESSMENT: 'nonBankQuickAssessment',
  LOAN_BOOK_BREAKDOWN: 'nonBankLoanBookBreakdown',
  DEPOSIT_AND_CREDIT: 'nonBankDepositAndCredit',
  AVERAGE_COST: 'nonBankAverageCost',
  EARNING_QUALITY: 'nonBankEarningQuality',
  CAPITAL_AND_LEVERAGE: 'nonBankCapitalAndLeverage',
  LIQUIDITY: 'nonBankLiquidity',
  FUNDING_STRUCTURE: 'nonBankFundingStructure',
  BALANCE_BREAKDOWN: 'nonBankBalanceBreakdown',
  EARNING_BREAKDOWN: 'nonBankEarningBreakdown',
  CASH_FLOW: 'nonBankCashFlow',
}

export const typeComponentSecurity = {
  OPERATING_INCOME: 'operatingIncome',
  BUSINESS_POSITION: 'businessPosition',
  FINANCIAL_ASSET: 'financialAsset',
  EARNING_QUALITY: 'earningQualitySecurity',
  LEVERAGE: 'leverage',
  FUNDING_AND_LIQUIDITY: 'fundingAndLiquidity',
  EARNING_BREAKDOWN: 'securityEarningBreakdown',
  BALANCE_BREAKDOWN: 'securityBalanceBreakdown',
  CASH_FLOW: 'securityCashFlow',
}

export const typeComponentLifeInsurance = {
  INSURANCE_PREMIUM_REVENUE: 'lifeInsInsurancePremiumRevenue',
  OPERATIONAL_EFFICIENCY: 'lifeInsOperationalEfficiency',
  PROFITABILITY: 'lifeInsProfitability',
  ROA_AND_ROE: 'lifeInsRoaAndRoe',
  INSURANCE_SOLVENCY: 'lifeInsInsuranceSolvency',
  LIQUIDITY: 'lifeInsLiquidity',
  BALANCE_BREAKDOWN: 'lifeInsBalanceBreakdown',
  EARNING_BREAKDOWN: 'lifeInsEarningBreakdown',
  CASH_FLOW: 'lifeInsCashFlow',
}

export const typeComponentNonLifeInsurance = {
  INSURANCE_PREMIUM_REVENUE: 'nonLifeInsInsurancePremiumRevenue',
  OPERATIONAL_EFFICIENCY: 'nonLifeInsOperationalEfficiency',
  PROFITABILITY: 'nonLifeInsProfitability',
  ROA_AND_ROE: 'nonLifeInsRoaAndRoe',
  INSURANCE_SOLVENCY: 'nonLifeInsInsuranceSolvency',
  LIQUIDITY: 'nonLifeInsLiquidity',
  BALANCE_BREAKDOWN: 'nonLifeInsBalanceBreakdown',
  EARNING_BREAKDOWN: 'nonLifeInsEarningBreakdown',
  CASH_FLOW: 'nonLifeInsCashFlow',
}

export const typeViewBy = {
  TREND: 'Trend',
  EACH_YEAR: 'Each year',
  TABLE: 'Table',
}

export const companyTypes = [
  COMPANY_TYPES.CORPORATE,
  COMPANY_TYPES.BANK,
  COMPANY_TYPES.SECURITIES,
  COMPANY_TYPES.NON_BANK,
  COMPANY_TYPES.LIFE_INSURANCE,
  COMPANY_TYPES.NON_LIFE_INSURANCE,
]
